import ExceptionHandling from './ExceptionHandling.js'
import { useStore, ActionTypes } from "../store";
import instance from './index';

export default class RequestedItemService {

	getItems(storeID,keyword,start) {
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/requested_items_list';
		const formData = new FormData();
		formData.append('keyword', keyword);
		formData.append('start', start);
		formData.append('storeID', storeID);
		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then(res => res.data)
		.catch((e) => ExceptionHandling.HandleErrors(e))
		.finally(() => {
			store.dispatch(ActionTypes.PROGRESS_BAR, false);
		})
	}

	saveItem(postObj,stateObj,currentStoreID,) {
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/add_requested_items';
		const formData = new FormData();
		formData.append('customer_name', stateObj.customerName);
		formData.append('contact_number', stateObj.contactNumber);
		formData.append('item_name', stateObj.requestedItem);
		formData.append('quantity', postObj.quantity);
		formData.append('description', postObj.description);
		formData.append('status', postObj.status);
		formData.append('branch_id', currentStoreID);
		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then(res => res.data)
			.catch((e) => ExceptionHandling.HandleErrors(e))
			.finally(() => {
				store.dispatch(ActionTypes.PROGRESS_BAR, false);
			})
	}

	updateItem(postObj,stateObj) {
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/edit_requested_items';
		const formData = new FormData();
		// Append the updated values to formData
		formData.append('customer_name', stateObj.customerName || '');
		formData.append('contact_number', stateObj.contactNumber || '');
		formData.append('id', postObj.id || '');
		formData.append('item_name', stateObj.requestedItem || '');
		formData.append('quantity', postObj.quantity || '');
		formData.append('description', postObj.description || '');
		return instance()(
		{
			method: 'post',
			url: api,
			data: formData,
		}).then((res) => {
			return res.data;
		}).catch((e) => {
			ExceptionHandling.HandleErrors(e);
		}).finally(() => {
			store.dispatch(ActionTypes.PROGRESS_BAR, false);
		});
	}

	getItem(data) {
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/get_requested_items/' + data.id;
		return instance().get(api)
			.then(res => res.data)
			.catch((e) => ExceptionHandling.HandleErrors(e))
			.finally(() => {
				store.dispatch(ActionTypes.PROGRESS_BAR, false);
			})
	}

	changeStatus(postObj) {
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/delete_requested_items';
		const formData = new FormData();
		formData.append('id', postObj.id);
		formData.append('status', postObj.status);
		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then(res => res.data)
			.catch((e) => ExceptionHandling.HandleErrors(e))
			.finally(() => {
				store.dispatch(ActionTypes.PROGRESS_BAR, false);
			})
	}

	sendSMS(stateObj,postObj) {
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/send_sms'; // Define your API endpoint
		const formData = new FormData();
		formData.append('customer_name', stateObj.customerName);
		formData.append('contact_number', stateObj.contactNumber);
		formData.append('item_name',stateObj.requestedItem);
		formData.append('id', postObj.id || '');
		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then((res) => {
			return res.data;
			})
			.catch((e) => ExceptionHandling.HandleErrors(e))
			.finally(() => {
				store.dispatch(ActionTypes.PROGRESS_BAR, false);
			})
	
	  }  

	  searchItem(keyword) {
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/search_items';
		const formData = new FormData();
		formData.append('keyword', keyword);

		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then(res => res.data)
			.catch((e) => ExceptionHandling.HandleErrors(e))
			.finally(() => {
				store.dispatch(ActionTypes.PROGRESS_BAR, false);
			})
	}
	
	getReceiptData(receiptID) {
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/get_pos_receipt';
		const formData = new FormData();
		formData.append('id', receiptID);

		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then(res => res.data)
			.catch((e) => ExceptionHandling.HandleErrors(e))
			.finally(() => {
				store.dispatch(ActionTypes.PROGRESS_BAR, false);
			})
	}
}